import ServiceEndpoint = OSF.ServiceEndpoint;
import 'owa-addins-osfruntime';

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'LaunchUrl',
        (data: any) => {
            let url: string = data;
            window.open(url);
            return null;
        },
        Microsoft.Office.Common.InvokeType.sync,
        false /* isBlocking */
    );
}
